import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/locaties')({
  beforeLoad: () => {
    throw redirect({ to: '/kaart', replace: true });
  },
});
